import { render, staticRenderFns } from "./TaskNodeConfig.vue?vue&type=template&id=d4b489da&scoped=true"
import script from "./TaskNodeConfig.vue?vue&type=script&lang=js"
export * from "./TaskNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskNodeConfig.vue?vue&type=style&index=0&id=d4b489da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b489da",
  null
  
)

export default component.exports